import Vue from 'vue'

import ExternalStoreMapper from '@/utilities/store-external-mappers'
import router from '@/router'
import store from '@/store'

import { SHARED_NAMESPACE } from '@/store/shared'

const VueRouteStore = {
  install (app, options) {
    const { router, store } = options
    const mapper = new ExternalStoreMapper(store)

    const actions = mapper.mapActions(SHARED_NAMESPACE, [
      'updateRSState',
    ])

    router.beforeEach((to, from, next) => {
      actions.updateRSState(from)
      next()
    })
  },
}

Vue.use(VueRouteStore, { router, store })
